import { html, nothing } from "lit";

export type BibleSummaryView = {
  done: string[];
  notDone: string[];
  why: string[];
  changed: string[];
  nextSteps: string[];
};

const FINAL_PLAN_STATUSES = new Set(["completed", "failed", "abandoned", "stopped"]);

export function bibleSummaryIsFinal(params: {
  planStatus?: string;
  requiresDecision?: boolean;
}): boolean {
  if (params.requiresDecision) {
    return true;
  }
  return FINAL_PLAN_STATUSES.has(params.planStatus ?? "");
}

export function renderBibleFinalSummaryCard(
  summary: BibleSummaryView | null | undefined,
  opts?: { planStatus?: string; requiresDecision?: boolean },
) {
  if (!summary) {
    return nothing;
  }
  const hasContent =
    summary.done.length +
      summary.notDone.length +
      summary.why.length +
      summary.changed.length +
      summary.nextSteps.length >
    0;
  if (!hasContent) {
    return nothing;
  }
  const isFinal = bibleSummaryIsFinal(opts ?? {});
  const section = (title: string, items: string[]) =>
    items.length === 0
      ? nothing
      : html`
          <div class="work-plan-summary__section">
            <div class="field-label">${title}</div>
            <ul>
              ${items.map((line) => html`<li>${line}</li>`)}
            </ul>
          </div>
        `;
  return html`
    <div class="work-plan-summary" data-testid="work-plan-summary">
      <div class="work-plan-summary__title">${isFinal ? "Final summary" : "Plan summary"}</div>
      ${section("Done", summary.done)} ${section("Not done", summary.notDone)}
      ${section("Why", summary.why)} ${section("Changed", summary.changed)}
      ${section("Next steps", summary.nextSteps)}
    </div>
  `;
}
